// import { paths } from "src/routes/paths";
import { t } from "i18next";
import { ICONS, liveStreamIcon, settingIcon } from "./menuIcons";
import { useProviderPaths } from "./useProviderPaths";

export function getOrganiserNav(
  currentProviderType: string
): { subheader: string; items: any }[] {
  const paths = useProviderPaths(currentProviderType);

  return [
    {
      subheader: "",
      items: [
        {
          title: t("mainpage"),
          path: paths.home,
          icon: ICONS.dashboard,
        },
      ],
    },
    {
      subheader: t("dashboard"),
      items: [
        {
          title: t("profile_data"),
          path: paths.profile.data,
          icon: ICONS.file,
          children: [
            {
              title: t("profile"),
              path: paths.profile.data,
            },
            { title: t("images"), path: paths.profile.images },
            { title: t("sports"), path: paths.profile.sports },
            {
              title: t("billing_infos"),
              path: paths.profile.billing_infos,
            },
            // { title: t("staff"), path: paths.dashboard.profile.staff },
          ],
        },
        {
          title: t("settings"),
          path: paths.settings.global,
          icon: settingIcon,
          children: [
            {
              title: t("global_settings"),
              path: paths.settings.global,
            },
          ],
        },
        {
          title: t("tournaments"),
          path: paths.tournaments,
          icon: ICONS.tour,
        },

        {
          title: t("rankings"),
          path: paths.rankings,
          icon: ICONS.file,
        },

        {
          title: t("players_and_teams"),
          path: paths.players_and_teams.players,
          icon: ICONS.user,
          children: [
            {
              title: t("players"),
              path: paths.players_and_teams.players,
            },
            {
              title: t("teams"),
              path: paths.players_and_teams.teams,
            },
          ],
        },

        {
          title: t("analytics"),
          path: paths.analytics,
          icon: ICONS.analytics,
        },
        {
          title: t("payment_management"),
          path: paths.payment_management,
          icon: ICONS.payment_management,
        },
        {
          title: t("newsfeed"),
          path: paths.post.root,
          icon: ICONS.blog,
          children: [
            { title: t("news"), path: paths.post.root },
            { title: t("add_new"), path: paths.post.new },
          ],
        },
        {
          title: t("livestreaming"),
          path: paths.livestreaming,
          icon: liveStreamIcon,
        },
        {
          title: t("adminuser_management"),
          path: paths.adminuser_management,
          icon: ICONS.adminuser_management,
        },
      ],
    },
  ];
}
